import React, { Component, Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import { groupsForBlobType, keyLabel } from "./registry";
import "./index.css";

function KeyCombo({ keys }) {
  return (
    <span className="blob-shortcut-keys">
      {keys.map((token, index) => (
        <Fragment key={index}>
          {index > 0 && <span className="blob-shortcut-plus">+</span>}
          <kbd className="blob-shortcut-key">{keyLabel(token)}</kbd>
        </Fragment>
      ))}
    </span>
  );
}

// The "?" keyboard-shortcuts help popup. Shows the Global section plus the
// sections that apply to the current blob's type, in a responsive column grid.
export default class ShortcutsModal extends Component {
  render() {
    const blob = this.props.blob;
    const typeKey = blob ? `${blob.domain}:${blob.type}` : null;
    const groups = groupsForBlobType(typeKey);

    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        size="lg"
        centered
        dialogClassName="blob-shortcuts-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Keyboard Shortcuts</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="blob-shortcuts-grid">
            {groups.map((group, groupIndex) => (
              <section className="blob-shortcut-group" key={groupIndex}>
                <h6 className="blob-shortcut-group-title">{group.title}</h6>
                {group.sections.map((subsection, subIndex) => (
                  <div className="blob-shortcut-subsection" key={subIndex}>
                    {subsection.title &&
                      <div className="blob-shortcut-subsection-title">{subsection.title}</div>
                    }
                    <ul className="blob-shortcut-list">
                      {subsection.shortcuts.map((shortcut, rowIndex) => (
                        <li className="blob-shortcut-row" key={rowIndex}>
                          <span className="blob-shortcut-label">
                            {shortcut.label}
                            {shortcut.note &&
                              <span className="blob-shortcut-note">{shortcut.note}</span>
                            }
                          </span>
                          <KeyCombo keys={shortcut.keys} />
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </section>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer className="blob-shortcuts-footer">
          <span className="blob-shortcuts-footer-note">
            Shortcuts stay out of your way while you’re typing — they’re ignored in text fields.
          </span>
          <span className="blob-shortcuts-footer-hint">
            <kbd className="blob-shortcut-key">Esc</kbd>&nbsp;to close
          </span>
        </Modal.Footer>
      </Modal>
    );
  }
}
